import { Ride } from '@geovelo-frontends/commons';
import { Skeleton, Typography } from '@mui/material';
import { Link } from 'gatsby';
import React from 'react';
import { useTranslation } from 'react-i18next';

function Breadcrumb({ ride }: { ride: Ride | undefined }): React.JSX.Element {
  const {
    t,
    i18n: { language: currentLanguage },
  } = useTranslation();

  return ride ? (
    <>
      <Typography color="textSecondary" variant="body2">
        <Typography color="primary" component="span" variant="body2">
          <Link
            style={{ color: 'inherit', textDecoration: 'none' }}
            to={`/${currentLanguage}/rides`}
          >
            {t('geovelo.navigation.rides')}
          </Link>
        </Typography>{' '}
        / {ride.title}
      </Typography>
    </>
  ) : (
    <Typography variant="body2">
      <Skeleton variant="text" width={200} />
    </Typography>
  );
}

export default Breadcrumb;
